import { createContext } from 'react';
import type { NavbarMenuListContextType } from './NavbarMenuListProvider';

export const NavbarMenuListContext = createContext<NavbarMenuListContextType | undefined>(undefined);
